// Amherst College's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from
// Amherst's official Majors page (amherst.edu/academiclife/departments), which lists
// every departmental and program major; all lead to the Bachelor of Arts. The page
// says 43 majors and lists 42 by name; the 42 listed are kept. The page's ampersands
// are written as "and". Interdisciplinary (student-designed) majors are left out.
const majors = {
    "slug": "amherst-college",
    "read": "2026-10-01",
    "intro": "Every major on Amherst's official Majors page. Every Amherst major leads to the Bachelor of Arts, and you may also propose an interdisciplinary major of your own.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Amherst College, Majors",
                "url": "https://www.amherst.edu/academiclife/departments"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Architectural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art and the History of Art",
                    "degree": "B.A."
                },
                {
                    "name": "Asian American and Pacific Islander Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Languages and Civilizations",
                    "degree": "B.A."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Biophysics",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Black Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education Studies",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Greek",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Latinx and Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Law, Jurisprudence and Social Thought",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Sexuality, Women's and Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Theater and Dance",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
